import router from '@/router'
// mutations
const CAFETERIA_REPORTS_ALL = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
  } else {
    alert(cafeteriaReports.message)
    state.status = 'error'
  }
}

const CAFETERIA_REPORTS_FORM = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
  } else {
    alert(cafeteriaReports.message)
    state.status = 'error'
  }
}

const CAFETERIA_REPORTS_SHOW = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
  } else {
    alert(cafeteriaReports.message)
    state.status = 'error'
  }
}

const CAFETERIA_REPORTS_CREATE = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
    alert(cafeteriaReports.message)
  } else {
    alert(cafeteriaReports.message)
    state.status = 'error'
  }
}

const CAFETERIA_REPORTS_UPDATE = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
    alert(cafeteriaReports.message)
  } else {
    alert(cafeteriaReports.message)
    state.status = 'error'
  }
}

const CAFETERIA_REPORTS_DELETE = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
    //router.push('/cafeteria/reversion')
    location.reload()
    alert(cafeteriaReports.message)
  } else {
    alert(cafeteriaReports.message)
    state.status = 'error'
  }
}

const CAFETERIA_REPORTS_PERMISS_LIST = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
  } else {
    alert(cafeteriaReports.message)
    state.status = 'error'
  }
}

const CAFETERIA_REPORTS_REPORTS_LIST = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}
const CAFETERIA_REPORTS_REPORTS_RVDP = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}
const CAFETERIA_REPORTS_REPORTS_RM = (state, cafeteriaReports) => {
  if (cafeteriaReports.code === 1) {
    state.cafeteriaReports = cafeteriaReports.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

export default {
  CAFETERIA_REPORTS_ALL,
  CAFETERIA_REPORTS_FORM,
  CAFETERIA_REPORTS_SHOW,
  CAFETERIA_REPORTS_CREATE,
  CAFETERIA_REPORTS_UPDATE,
  CAFETERIA_REPORTS_DELETE,
  CAFETERIA_REPORTS_PERMISS_LIST,
  CAFETERIA_REPORTS_REPORTS_LIST,
  CAFETERIA_REPORTS_REPORTS_RVDP,
  CAFETERIA_REPORTS_REPORTS_RM
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/reports/mutations.js